// extracted by mini-css-extract-plugin
module.exports = {"Container":"PaymentSuccess_Container__29xhb","Graphic":"PaymentSuccess_Graphic__2D2cL"};